import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "./CompleteProfileLocation.scss";

const CompleteProfileLocation: React.FC = () => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    register,
  } = useForm({});
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    console.log(data);
    navigate("/sign-up/success");
  };

  return (
    <>
      {/* <div className="sign-up-location__caption">
        <p className="sign-up-location__caption-title">Location</p>
        <p className="sign-up-location__caption-subtitle">
          Indicate where you or your organization are located to have the best
          experience based on it
        </p>
      </div>

      <form
        className="sign-up-location__input-container"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="sign-up-location__input">
          <img
            src={require("../../../assets/images/searchIcon.png")}
            className="sign-up-location__search-icon"
          />
          <AcedInput
            placeHolder="Search"
            control={control}
            className="text-input--no-background"
            register={register("search")}
          ></AcedInput>
        </div>

        <Button className="btn btn-primary ">Confirm</Button>
      </form> */}
    </>
  );
};

export default CompleteProfileLocation;
